<template>
  <div class="tsmanifestMain" ref="tsmanifestMain" :style="{ 
    'width': '100%',
    'height': '100%',
    'position': 'relative'}">

    <div class="truckManifestHeader" :style="{
      'width': ((738 * zoomLevel) + 'px'),
      'height': ((57 * zoomLevel) + 'px'),
      'position': 'absolute',
      'top': (((3 * zoomLevel) + 18) + 'px'),
      'left': ((39 * zoomLevel) + 'px'), }">

      <div class="TMSJINo" :style="{
        'width': ((130 * zoomLevel) + 'px'),
        'height': ((30 * zoomLevel) + 'px'),
        'font-size': ((20 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((15 * zoomLevel) + 'px'),
        'right': '33px', 
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-end'}">
        {{properties ? (properties['details'] ? (properties['details']['JHTMSJINO'] ? properties['details']['JHTMSJINO'] : '') : '') : ''}}
        {{print ? '' : 'TMSJINo'}}
      </div>

      <div class="pageNo" :style="{
        'width': ((130 * zoomLevel) + 'px'),
        'height': ((30 * zoomLevel) + 'px'),
        'font-size': ((13 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((33 * zoomLevel) + 'px'),
        'right': '33px', 
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-end'}">
        {{properties ? (properties['jobs'] ? (properties['jobs'][0]['page'] ? properties['jobs'][0]['page'] : '') : '') : ''}} page
        {{print ? '' : 'pageNo'}}
      </div>

      <div class="date" :style="{
        'width': ((110 * zoomLevel) + 'px'),
        'height': ((20 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((18 * zoomLevel) + 'px'),
        'right': ((220 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['details'] ? (properties['details']['JHDateIssued'] ? properties['details']['JHDateIssued'] : '') : '') : ''}}
        {{print ? '' : 'date'}}
      </div>

      <div class="day" :style="{
        'width': ((110 * zoomLevel) + 'px'),
        'height': ((20 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((36 * zoomLevel) + 'px'),
        'right': ((220 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['details'] ? (properties['details']['JHDay'] ? properties['details']['JHDay'] : '') : '') : ''}}
        {{print ? '' : 'day'}}
      </div>

    </div>

    <!-- Store Job Details -->
    <div class="truckManifestMain" v-for="(j, i) in 3" :key="'job' + i" :style="{ 
      'width': ((738 * zoomLevel) + 'px'),
      'height': ((248 * zoomLevel) + 'px'),
      'position': 'absolute',
      'top': (((90 + (268 * i)) * zoomLevel) + 'px'),
      'left': ((39 * zoomLevel) + 'px'), }">

      <div class="destCode" :style="{
        'width': ((30 * zoomLevel) + 'px'),
        'height': ((20 * zoomLevel) + 'px'),
        'text-align': 'center',
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((40 * zoomLevel) + 'px'),
        'left': ((0 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center'}">
        {{properties ? (properties['jobs'] ? (properties['jobs'][i] ? (properties['jobs'][i]['DestinationCode'] ? properties['jobs'][i]['DestinationCode'] : '') : '') : '') : ''}}
        {{print ? '' : 'destCode'}}
      </div>

      <div class="seqNo" :style="{
        'width': ((30 * zoomLevel) + 'px'),
        'height': ((20 * zoomLevel) + 'px'),
        'text-align': 'center',
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((70 * zoomLevel) + 'px'),
        'left': ((0 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center'}">
        {{properties ? (properties['jobs'] ? (properties['jobs'][i] ? (properties['jobs'][i]['DropSeqNo'] ? ('Drop ' + (properties['jobs'][i]['DropSeqNo'])) : '') : '') : '') : ''}}
        {{print ? '' : 'seqNo'}}
      </div>

      <div class="ist" v-if="(properties && properties['jobs'][i] && properties['jobs'][i]['Consignment']) || !print" :style="{
        'width': ((140 * zoomLevel) + 'px'),
        'height': ((120 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((20 * zoomLevel) + 'px'),
        'left': ((45 * zoomLevel) + 'px'),
        'display': 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        <div class="istDetails" v-for="(c, i2) in (print ? (properties['jobs'][i]['Consignment']) : [])" :key="'ist' + i2" :style="{
          'width': '100%',
          'height': ((12 * zoomLevel) + 'px'),
          'font-size': ((14 * zoomLevel) + 'px'),
          'display': 'flex',
          'align-items': 'center',
          'justify-content': 'flex-start'}">
          {{c['IST No'] ? c['IST No'] : '0'}}
        </div>
        {{print ? '' : 'istNo'}}
      </div>

      <div class="truckManifest" v-if="(properties && properties['jobs'][i] && properties['jobs'][i]['Consignment']) || !print" :style="{
        'width': ((115 * zoomLevel) + 'px'),
        'height': ((120 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((20 * zoomLevel) + 'px'),
        'left': ((215 * zoomLevel) + 'px'),
        'display': 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        <div class="truckDetails" v-for="(c, i2) in (print ? (properties['jobs'][i]['Consignment']) : [])" :key="'truck' + i2" :style="{
          'width': '100%',
          'height': ((12 * zoomLevel) + 'px'),
          'font-size': ((14 * zoomLevel) + 'px'),
          'display': 'flex',
          'align-items': 'center',
          'justify-content': 'flex-start'}">
          {{c['Manifest No'] ? c['Manifest No'] : '0'}}
        </div>
        {{print ? '' : 'manifestNo'}}
      </div>

      <div class="scanCode" :id="properties ? (properties['jobs'] ? (properties['jobs'][i] ? (properties['jobs'][i]['Consignment'] ? (properties['jobs'][i]['Consignment'][0] ? (properties['jobs'][i]['Consignment'][0]['ConsignmentNo'] ? properties['jobs'][i]['Consignment'][0]['ConsignmentNo'].trim() : '') : '') : '') : '') : '') : ''" :style="{
        'width': ((55 * zoomLevel) + 'px'), //110
        'height': ((55 * zoomLevel) + 'px'), //110
        'background-size': ((55 * zoomLevel) + 'px'), //110
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'position': 'absolute',
        'top': ((20 * zoomLevel) + 'px'), //24
        'left': ((280 * zoomLevel) + 'px'),
        //'right': ((8 * zoomLevel) + 'px'), 
        'display': 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{print ? '' : 'scanCode'}}
      </div>

      <!-- <div class="scanCode" :id="properties ? (properties['jobs'] ? (properties['jobs'][i] ? (properties['jobs'][i]['Consignment'] ? (properties['jobs'][i]['Consignment'][0] ? (properties['jobs'][i]['Consignment'][0]['ConsignmentNo'] ? properties['jobs'][i]['Consignment'][0]['ConsignmentNo'].trim() : '') : '') : '') : '') : '') : ''" :style="{
        'width': ((110 * zoomLevel) + 'px'),
        'height': ((110 * zoomLevel) + 'px'),
        'background-size': ((110 * zoomLevel) + 'px'),
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'position': 'absolute',
        'top': ((24 * zoomLevel) + 'px'),
        'right': ((8 * zoomLevel) + 'px'),
        'display': 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{print ? '' : 'scanCode'}}
      </div> -->

      <div class="company" :style="{
        'width': ((172 * zoomLevel) + 'px'),
        'height': ((40 * zoomLevel) + 'px'),
        'line-height': ((14 * zoomLevel) + 'px'),
        'font-size': ((12 * zoomLevel) + 'px'),
        'font-weight': 'bold',
        'position': 'absolute',
        'top': ((24 * zoomLevel) + 'px'),
        'left': ((430 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'flex-start',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['jobs'] ? (properties['jobs'][i] ? (properties['jobs'][i]['DestinationName'] ? properties['jobs'][i]['DestinationName'] : '') : '') : '') : ''}}
        {{print ? '' : 'company'}}
      </div>

      <div class="address" :style="{
        'width': ((286 * zoomLevel) + 'px'),
        'height': ((68 * zoomLevel) + 'px'),
        'line-height': ((14 * zoomLevel) + 'px'),
        'font-size': ((12 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((79 * zoomLevel) + 'px'),
        'left': ((430 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'flex-start',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['jobs'] ? (properties['jobs'][i] ? (properties['jobs'][i]['DestinationAddress'] ? properties['jobs'][i]['DestinationAddress'] : '') : '') : '') : ''}}
        {{print ? '' : 'address'}}
      </div>

      <div class="TMSWithPage" :style="{
        'width': ((286 * zoomLevel) + 'px'),
        'height': ((24 * zoomLevel) + 'px'),
        'font-size': ((12 * zoomLevel) + 'px'),
        'position': 'absolute',
        'bottom': '20px',
        'left': ((425 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-end'}">
        {{properties ? (properties['details'] ? (properties['details']['JHTMSJINO'] ? properties['details']['JHTMSJINO'] : '') : '') : ''}} 
        Page {{properties ? (properties['jobs'] ? (properties['jobs'][0]['page'] ? properties['jobs'][0]['page'] : '') : '') : ''}} ({{i + 1}}/3)
        {{print ? '' : 'jobNo'}} 
      </div>

      <div class="jobNo" :style="{
        'width': ((172 * zoomLevel) + 'px'),
        'height': ((24 * zoomLevel) + 'px'),
        'font-size': ((16 * zoomLevel) + 'px'),
        'position': 'absolute',
        'bottom': '0px',
        'right': '0px',
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['jobs'] ? (properties['jobs'][i] ? (properties['jobs'][i]['JobNo'] ? properties['jobs'][i]['JobNo'] : '') : '') : '') : ''}}
        {{print ? '' : 'jobNo'}}
      </div>
    </div>

    <!-- Gate Pass Details -->
    <div class="truckManifestGatepass" :style="{ 
      'width': ((738 * zoomLevel) + 'px'),
      'height': ((176 * zoomLevel) + 'px'),
      'position': 'absolute',
      'bottom': (((20 * zoomLevel) + 20) + 'px'),
      'left': ((39 * zoomLevel) + 'px'), }">

      <div class="lorryNo" :style="{
        'width': ((205 * zoomLevel) + 'px'),
        'height': ((16 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((19 * zoomLevel) + 'px'),
        'left': ((140 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['details'] ? (properties['details']['Lorry_No'] ? properties['details']['Lorry_No'] : '') : '') : ''}}
        {{print ? '' : 'lorryNo'}}
      </div>

      <div class="vehicleCode" :style="{
        'width': ((205 * zoomLevel) + 'px'),
        'height': ((16 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((33 * zoomLevel) + 'px'),
        'left': ((140 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['details'] ? (properties['details']['JHVehicleCode'] ? properties['details']['JHVehicleCode'] : '') : '') : ''}}
        {{print ? '' : 'vehicleCode'}}
      </div>
      
      <div class="driverName" :style="{
        'width': ((205 * zoomLevel) + 'px'),
        'height': ((16 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((60 * zoomLevel) + 'px'),
        'left': ((140 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['details'] ? (properties['details']['DriverName'] ? properties['details']['DriverName'] : '') : '') : ''}}
        {{print ? '' : 'driverName'}}
      </div>
      
      <div class="NRIC" :style="{
        'width': ((205 * zoomLevel) + 'px'),
        'height': ((16 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((87 * zoomLevel) + 'px'),
        'left': ((140 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['details'] ? (properties['details']['EStaff_NRIC'] ? properties['details']['EStaff_NRIC'] : '') : '') : ''}}
        {{print ? '' : 'NRIC'}}
      </div>
      
      <div class="mobileNo" :style="{
        'width': ((205 * zoomLevel) + 'px'),
        'height': ((16 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((115 * zoomLevel) + 'px'),
        'left': ((140 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['details'] ? (properties['details']['EStaff_MobileNo'] ? properties['details']['EStaff_MobileNo'] : '') : '') : ''}}
        {{print ? '' : 'mobileNo'}}
      </div>
      
      <div class="ownership" :style="{
        'width': ((205 * zoomLevel) + 'px'),
        'height': ((16 * zoomLevel) + 'px'),
        'font-size': ((14 * zoomLevel) + 'px'),
        'position': 'absolute',
        'top': ((140 * zoomLevel) + 'px'),
        'left': ((140 * zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'}">
        {{properties ? (properties['details'] ? (properties['details']['OwnerShip'] ? properties['details']['OwnerShip'] : '') : '') : ''}}
        {{print ? '' : 'ownership'}}
      </div>

    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  
  export default {
    name: 'designerTSManifest',
    components: {
      
    },
    props: {
      data: { type: Object, default: function() { return {}; }},
      printData: { type: Object, default: function() { return {}; }},

      properties: { type: Object, default: function() { return null; }},
      zoomLevel: { type: Number, default: 1 },
      fontPtPx: { type: Number, default: 1 },
      print: { type: Boolean, default: false },
    },
    data() { 
      return {
        
      }
    },
    computed: {
      
    },
    mounted() {
      console.log(this.properties);
      // console.log(this.properties);
      this.getQRCodeImg();
    },
    beforeDestroy() {
      
    },
    methods: {
      getQRCodeImg() {
        // console.log(this.properties['jobs']);
        //-- Clear scanCode DOMs
        Array.from(document.getElementsByClassName('scanCode')).forEach((s, i) => {
          if (!s['id']) { s['style']['background-image'] = ''; }
        });

        //-- Insert QR Codes
        if (this.properties['jobs']['length'] > 0) {
          this.properties['jobs'].forEach((j, i) => {
            if (j && j['Consignment']['length'] > 0) {
              var scanDOM = document.getElementById(j['Consignment'][0]['ConsignmentNo']);
              // console.log(scanDOM);

              var qrDOM = document.createElement('div');
              new QRCode(qrDOM, {
                text: JSON.stringify({ 'CNNO': j['Consignment'][0]['ConsignmentNo'] }),
                width: 800,
                height: 800,
              });
              
              var qrImg = Array.from(qrDOM.childNodes)[1];
              setTimeout(() => {
                scanDOM['style']['background-image'] = 'url(\'' + qrImg['src'] + '\')';
              }, 1);
            }
          });
        }
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
      properties: { deep: true, handler(h) { setTimeout(() => { this.getQRCodeImg(); }, 1); } }
    },
  };
</script>

<style scoped>
  @font-face {
      font-family: 'Libre Barcode 128 Text';
      src: url('https://fonts.googleapis.com/css?family=Libre Barcode 128 Text');
  }

  /* * {
    border: solid 1px red;
  } */

  /* .tsmanifestMain {
    width: 100%;
    height: 100%;
    position: relative;
  } */
/* 
  .truckManifestMain {
    width: auto;
    height: auto;
    position: absolute;
  }

  .destCode {
    width: auto;
    text-align: center;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seqNo {
    width: auto;
    text-align: center;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ist {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .istDetails {
    width: 100%;
    height: auto;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .truckManifest {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .truckDetails {
    width: 100%;
    height: auto;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .company {
    position: absolute;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-weight: bold;
  }
  
  .address {
    position: absolute;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .jobNo {
    position: absolute;
    bottom: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .truckManifestGatepass {
    width: auto;
    height: auto;
    position: absolute;
  }

  .vehicleCode {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .lorryNo {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .driverName {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .NRIC {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .mobileNo {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .ownership {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  } */
</style>